/*
 * File: AppointmentColor.js
 * Project: mp-mobile-app
 *
 * Created by jeddumire on 11/06/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Utility for styling appointment display based on colors object
 */
/**
 * Take a color string of any type (hex, rgba, color name, etc),
 * optionally reduce the opacity, and return in hex format
 *
 * @param {string} color color to transform
 * @param {number} [opacity=1] opacity to apply to color, fully opaque is default
 * @returns hex color string, including opacity ex: #C1424266
 */
const getColorRgbaString = (color, opacity = 1) => {
  const isHexColor = RegExp("^[0-9a-fA-F]*$").test(color);
  const colorString = isHexColor ? "#" + color : color;
  //Opacity is provided as % opaque, convert to hex value
  const opacityString = parseInt(opacity * 255).toString(16);

  //The next two lines convert whatever the input string is into hex rgb value
  let tempCanvas = document.createElement("canvas").getContext("2d");
  tempCanvas.fillStyle = colorString;
  const rgbaString = tempCanvas.fillStyle;

  //Add opacity to the end of the string
  return rgbaString + opacityString;
};

/**
 * Take colors object for an appointment and return a style object with borders set
 * accordingly
 * @param {Object} colors dictionary of colors
 * @param {number} [borderWidth=4] width of the borders
 * @returns object with backgroundColor and borders populated
 */
const getColorStyle = (colors, borderWidth = 4) => {
  const widthString = borderWidth + "px solid "; //EX: "4px solid "
  return {
    backgroundColor: getColorRgbaString(colors["color1"], 0.4),
    borderLeft: widthString + getColorRgbaString(colors["color3"]),
    borderTop: widthString + getColorRgbaString(colors["color2"]),
    borderBottom: widthString + getColorRgbaString(colors["color4"]),
    borderRight: widthString + getColorRgbaString(colors["color5"])
  };
};

const AppointmentColor = {
  getColorRgbaString: getColorRgbaString,
  getColorStyle: getColorStyle
};

export default AppointmentColor;
